import { Component, Injectable, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";

import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";

import * as FileSaver from "file-saver";
import * as moment from "moment";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable()
// Excel export code end here

@Component({
  selector: "app-cibil-commercial",
  templateUrl: "./cibil-commercial.component.html",
  styleUrls: ["./cibil-commercial.component.scss"],
})
export class CibilCommercialReportComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  textString: any;
  ToDate: any = new Date();
  DataSourceBS: any;
  DataSourceAS: any;
  DataSourceRS: any;
  DataSourceCR: any;
  DataSourceGS: any;
  DataSourceSS: any;
  DataSourceCD: any;
  DataSourceTS: any;
  Show: any = false;
  JSONData: any;
  JSONASData: any[] = [];
  CRCModel: any = { MemberId: "", PreviousMemberId: "" };
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumnsBS: string[] = [
    "LoanAcNo",
    "Flag",
    "Segment_Identifier",
    "Member_Branch_Code",
    "Previous_Member_Branch_Code",
    "Borrowers_Name",
    "Borrower_Short_Name",
    "Company_Registration_Number",
    "Date_of_Incorporation",
    "PAN",
    "CIN",
    "TIN",
    "Service_Tax",
    "Other_ID",
    "Borrowers_Legal_Constitution",
    "BusinessCategory",
    "BusinessType",
    "Borrowers_Legal_Constitution_Code",
    "BusinessCategory_Code",
    "BusinessType_Code",
    "Class_of_Activity_1",
    "Class_of_Activity_2",
    "Class_of_Activity_3",
    "SIC_Code",
    "Sales_Figure",
    "Financial_Year",
    "Number_of_Employees",
    "Credit_Rating",
    "Assessment_Agency_Authority",
    "Credit_Rating_As_On",
    "Credit_Rating_Expiry_Date",
  ];

  displayedColumnsAS: string[] = [
    "LoanAcNo",
    "Flag",
    "Segment_Identifier",
    "Borrower_Office_Location_Type",
    "Borrower_Office_DUNS_Number",
    "Address_Line_1",
    "Address_Line_2",
    "Address_Line_3",
    "City_Town",
    "District",
    "State_Union_Territory",
    "Pin_Code",
    "Country",
    "Mobile_Number",
    "Telephone_Area_Code",
    "Telephone_Number",
    "Fax_Area_Code",
    "Fax_Number",
  ];

  displayedColumnsRS: string[] = [
    "LoanAcNo",
    "Flag",
    "Segment_Identifier",
    "Relationship_DUNS_Number",
    "Related_Type",
    "Relationship",
    "Relationship_Name",
    "Business_Entity_Name",
    "BusinessCategory_Code",
    "BusinessType_Code",
    "Individual_Name_Prefix",
    "Full_Name",
    "Gender",
    "Company_Registration_Number",
    "Date_of_Incorporation",
    "Date_of_Birth",
    "PAN",
    "Voter_ID",
    "Passport_Number",
    "Driving_Licence_ID",
    "UID",
    "Ration_Card_No",
    "CIN",
    "DIN",
    "TIN",
    "Service_Tax",
    "Other_ID",
    "Percentage_of_Control",
    "Address_Line_1",
    "Address_Line_2",
    "Address_Line_3",
    "City_Town",
    "District",
    "State_Union_Territory",
    "Pin_Code",
    "Country",
    "Mobile_Number",
    "Telephone_Area_Code",
    "Telephone_Number",
    "Fax_Area_Code",
    "Fax_Number",
  ];

  displayedColumnsCR: string[] = [
    "Ac_No",
    "Flag",
    "Segment_Identifier",
    "Account_Number",
    "Previous_Account_Number",
    "Facility_Loan_Activation_Sanction_Date",
    "Sanctioned_Amount_Notional_Amount_of_Contract",
    "Currency_Code",
    "Credit_Type",
    "Tenure_Weighted_Average_maturity_period_of_Contracts",
    "Repayment_Frequency",
    "Drawing_Power",
    "Current_Balance_Limit_Utilized_Mark_to_Market",
    "Notional_Amount_of_Out_standing_Restructured_Contracts",
    "Loan_Expiry_Maturity_Date",
    "Loan_Renewal_Date",
    "Asset_Classification_Number_of_days_past_due_NDPD",
    "Asset_Classification_Date",
    "Amount_Overdue_Limit_Overdue",
    "Overdue_Bucket_01_1_30_days",
    "Overdue_Bucket_02_31_60_days",
    "Overdue_Bucket_03_61_90_days",
    "Overdue_Bucket_04_91_180_days",
    "Overdue_Bucket_05_Above_180_days",
    "High_Credit",
    "Installment_Amount",
    "Last_Repaid_Amount",
    "Account_Status",
    "Account_Status_Date",
    "Written_Off_Amount",
    "Settled_Amount",
    "Major_reasons_for_Restructuring",
    "Amount_of_Contracts_Classified_as_NPA",
    "Asset_based_Security_coverage",
    "Guarantee_Coverage",
    "Bank_Remark_Code",
    "Wilful_Default_Status",
    "Date_Classified_as_Wilful_Default",
    "Suit_Filed_Status",
    "Suit_Reference_Number",
    "Suit_Amount_in_Rupees",
    "Date_of_Suit",
    "Dispute_ID_No",
    "Transaction_Type_Code",
    "OTHER_BK",
    "UFCE_Amount",
    "UFCE_Date",
  ];

  displayedColumnsGS: string[] = [
    "A_c_No",
    "Flag",
    "Segment_Identifier",
    "Guarantor_DUNS_Number",
    "Guarantor_Type",
    "Business_Category",
    "Business_Industry_Type",
    "Guarantor_Entity_Name",
    "Individual_Name_Prefix",
    "Full_Name",
    "Gender",
    "Company_Registration_Number",
    "Date_of_Incorporation",
    "Date_of_Birth",
    "PAN",
    "Voter_ID",
    "Passport_Number",
    "Driving_Licence_ID",
    "UID",
    "Ration_Card_No",
    "CIN",
    "DIN",
    "TIN",
    "Service_Tax",
    "Other_ID",
    "Address_Line_1",
    "Address_Line_2",
    "Address_Line_3",
    "City_Town",
    "District",
    "State_Union_Territory",
    "Pin_Code",
    "Country",
    "Mobile_Number",
    "Telephone_Area_Code",
    "Telephone_Number",
    "Fax_Area_Code",
    "Fax_Number",
  ];

  displayedColumnsSS: string[] = [
    "A_c_No",
    "Flag",
    "Segment_Identifier",
    "Value_of_Security",
    "Currency_Type",
    "Type_of_Security",
    "Security_Classification",
    "Date_of_Valuation",
  ];

  displayedColumnsCD: string[] = [
    "A_c_No",
    "Flag",
    "Segment_Identifier",
    "Date_of_Dishonour",
    "Amount",
    "Instrument_Cheque_Number",
    "Number_of_times",
    "dishonoured_Cheque_Issue_Date",
    "Reason_for_Dishonour",
  ];

  displayedColumnsTS: string[] = [
    "Segment_identifier",
    "Number_of_Borrower_Segments",
    "Number_of_Credit_Facility_Segments",
  ];

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  selectedId: any;

  constructor(
    private dataSharingService: DataSharingService,
    private masterService: MasterService,
    private reportsService: ReportsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Cibil Commercial");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  onSearchReport() {
    this.showSpinner = true;
    this.reportsService
      .Report_Cibil_Commercial({ ReportDate: this.ToDate })
      .subscribe((res: any) => {
        //console.log(res);
        if (res.Item1.length > 0) {
          this.Show = true;

          this.JSONData = res;

          this.DataSourceBS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item1))
          );
          this.DataSourceAS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item2))
          );
          this.DataSourceRS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item3))
          );
          this.DataSourceCR = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item4))
          );
          this.DataSourceGS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item5))
          );
          this.DataSourceSS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item6))
          );
          this.DataSourceCD = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item7))
          );
          this.DataSourceTS = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item8))
          );
        } else {
          this.Show = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
        }
        this.showSpinner = false;
      });
  }

  // Excel export in backend start here
  public exportToExcel(): void {
    const worksheetBS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item1
    );
    const worksheetAS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item2
    );
    const worksheetRS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item3
    );
    const worksheetCR: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item4
    );
    const worksheetGS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item5
    );
    const worksheetSS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item6
    );
    const worksheetCD: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item7
    );
    const worksheetTS: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.JSONData.Item8
    );

    const workbook: XLSX.WorkBook = {
      Sheets: {
        BS: worksheetBS,
        AS: worksheetAS,
        RS: worksheetRS,
        CR: worksheetCR,
        GS: worksheetGS,
        SS: worksheetSS,
        CD: worksheetCD,
        TS: worksheetTS,
      },
      SheetNames: ["BS", "AS", "RS", "CR", "GS", "SS", "CD", "TS"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      "Cibil_Commercial" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  downloadTxtFile() {
    console.log(this.JSONData);
    console.log(this.JSONData?.Item1?.length);

    // 🧾 Header section
    this.textString = "HD|";
    this.textString += (this.CRCModel.MemberId || "") + "|";
    this.textString += (this.CRCModel.PreviousMemberId || "") + "|";
    this.textString += moment(new Date()).format("DDMMYYYY") + "|";
    this.textString += moment(this.ToDate).format("DDMMYYYY") + "|";
    this.textString += "01||";

    if (!this.JSONData?.Item1?.length) {
      console.warn("⚠️ No Item1 records found in JSONData");
      return;
    }

    const append = (val: any) =>
      (val != null && val !== "" ? val.toString() : "") + "|";

    const formatDate = (val: any) =>
      val
        ? moment(val, [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
            "MM/DD/YYYY",
            "YYYY/MM/DD",
          ]).isValid()
          ? moment(val).format("DDMMYYYY") + "|"
          : "|"
        : "|";

    for (let i = 0; i < this.JSONData.Item1.length; i++) {
      const item = this.JSONData.Item1[i];

      this.textString += "BS|";
      this.textString += append(item.Member_Branch_Code);
      this.textString += append(item.Previous_Member_Branch_Code);
      this.textString += append(item.Borrowers_Name);
      this.textString += append(item.Borrower_Short_Name);
      this.textString += append(item.Company_Registration_Number);

      this.textString += formatDate(item.Date_of_Incorporation);
      this.textString += append(item.PAN);
      this.textString += append(item.CIN);
      this.textString += append(item.TIN);
      this.textString += append(item.Service_Tax);
      this.textString += append(item.Other_ID);
      this.textString += append(item.Borrowers_Legal_Constitution_Code);
      this.textString += append(item.BusinessCategory_Code);
      this.textString += append(item.BusinessType_Code);
      this.textString += append(item.Class_of_Activity_1);
      this.textString += append(item.Class_of_Activity_2);
      this.textString += append(item.Class_of_Activity_3);
      this.textString += append(item.SIC_Code);
      this.textString += append(item.Sales_Figure);
      this.textString += append(item.Financial_Year);
      this.textString += append(item.Number_of_Employees);
      this.textString += append(item.Credit_Rating);
      this.textString += append(item.Assessment_Agency_Authority);

      this.textString += formatDate(item.Credit_Rating_As_On);
      this.textString += formatDate(item.Credit_Rating_Expiry_Date);
      this.textString += append(item.CKYC);

      // 🔹 AS Segment
      const ASSegment =
        this.JSONData.Item2?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];

      ASSegment.forEach((obj: any) => {
        this.textString += "AS|";
        this.textString += append(obj.Borrower_Office_Location_Type);
        this.textString += append(obj.Borrower_Office_DUNS_Number);
        this.textString += append(obj.Address_Line_1);
        this.textString += append(obj.Address_Line_2);
        this.textString += append(obj.Address_Line_3);
        this.textString += append(obj.City_Town);
        this.textString += append(obj.District);
        this.textString += append(obj.State_Union_Territory);
        this.textString += append(obj.Pin_Code);
        this.textString += append(obj.Country);
        this.textString += append(obj.Mobile_Number);
        this.textString += append(obj.Telephone_Area_Code);
        this.textString += append(obj.Telephone_Number);
        this.textString += append(obj.Fax_Area_Code);
        this.textString += append(obj.Fax_Number);
        this.textString += "||";
      });

      // 🔹 RS Segment
      const RSSegment =
        this.JSONData.Item3?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];

      RSSegment.forEach((obj: any) => {
        this.textString += "RS|";
        this.textString += append(obj.Relationship_DUNS_Number);
        this.textString += append(obj.Borrower_Office_DUNS_Number);
        this.textString += append(obj.Relationship);
        this.textString += append(obj.Relationship_Name);
        this.textString += append(obj.Business_Entity_Name);
        this.textString += append(obj.BusinessCategory_Code);
        this.textString += append(obj.BusinessType_Code);
        this.textString += formatDate(obj.Date_of_Incorporation);
        this.textString += append(obj.Gender);
        this.textString += append(obj.Full_Name);
        this.textString += append(obj.Company_Registration_Number);
        this.textString += formatDate(obj.Date_of_Birth);
        this.textString += append(obj.PAN);
        this.textString += append(obj.Voter_ID);
        this.textString += append(obj.Passport_Number);
        this.textString += append(obj.Driving_Licence_ID);
        this.textString += append(obj.UID);
        this.textString += append(obj.Ration_Card_No);
        this.textString += append(obj.CIN);
        this.textString += append(obj.DIN);
        this.textString += append(obj.TIN);
        this.textString += append(obj.Service_Tax);
        this.textString += append(obj.Other_ID);
        this.textString += append(obj.Percentage_of_Control);
        this.textString += append(obj.Address_Line_1);
        this.textString += append(obj.Address_Line_2);
        this.textString += append(obj.Address_Line_3);
        this.textString += append(obj.City_Town);
        this.textString += append(obj.District);
        this.textString += append(obj.State_Union_Territory);
        this.textString += append(obj.Pin_Code);
        this.textString += append(obj.Country);
        this.textString += append(obj.Mobile_Number);
        this.textString += append(obj.Telephone_Area_Code);
        this.textString += append(obj.Telephone_Number);
        this.textString += append(obj.Fax_Area_Code);
        this.textString += append(obj.Fax_Number);
        this.textString += "||";
      });

      // 🔹 CR Segment
      const CRSegment =
        this.JSONData.Item4?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];

      CRSegment.forEach((obj: any) => {
        this.textString += "CR|";
        this.textString += append(obj.Account_Number);
        this.textString += append(obj.Previous_Account_Number);
        this.textString += formatDate(
          item.Facility_Loan_Activation_Sanction_Date
        );
        this.textString += append(
          obj.Sanctioned_Amount_Notional_Amount_of_Contract
        );
        this.textString += append(obj.Currency_Code);
        this.textString += append(obj.Credit_Type);
        this.textString += append(
          obj.Tenure_Weighted_Average_maturity_period_of_Contracts
        );
        this.textString += append(obj.Repayment_Frequency);
        this.textString += append(obj.Drawing_Power);
        this.textString += append(
          obj.Current_Balance_Limit_Utilized_Mark_to_Market
        );
        this.textString += append(
          obj.Notional_Amount_of_Out_standing_Restructured_Contracts
        );
        this.textString += formatDate(item.Loan_Expiry_Maturity_Date);
        this.textString += formatDate(item.Loan_Renewal_Date);
        this.textString += append(
          obj.Asset_Classification_Number_of_days_past_due_NDPD
        );
        this.textString += formatDate(item.Asset_Classification_Date);
        this.textString += append(obj.Amount_Overdue_Limit_Overdue);
        this.textString += append(obj.Overdue_Bucket_01_1_30_days);
        this.textString += append(obj.Overdue_Bucket_02_31_60_days);
        this.textString += append(obj.Overdue_Bucket_03_61_90_days);
        this.textString += append(obj.Overdue_Bucket_04_91_180_days);
        this.textString += append(obj.Overdue_Bucket_05_Above_180_days);
        this.textString += append(obj.High_Credit);
        this.textString += append(obj.Installment_Amount);
        this.textString += append(obj.Last_Repaid_Amount);
        this.textString += append(obj.Account_Status);
        this.textString += formatDate(item.Account_Status_Date);
        this.textString += append(obj.Written_Off_Amount);
        this.textString += append(obj.Settled_Amount);
        this.textString += append(obj.Major_reasons_for_Restructuring);
        this.textString += append(obj.Amount_of_Contracts_Classified_as_NPA);
        this.textString += append(obj.Asset_based_Security_coverage);
        this.textString += append(obj.Guarantee_Coverage);
        this.textString += append(obj.Bank_Remark_Code);
        this.textString += append(obj.Wilful_Default_Status);
        this.textString += formatDate(item.Date_Classified_as_Wilful_Default);
        this.textString += append(obj.Suit_Filed_Status);
        this.textString += append(obj.Suit_Reference_Number);
        this.textString += append(obj.Suit_Amount_in_Rupees);
        this.textString += formatDate(item.Date_of_Suit);
        this.textString += append(obj.Dispute_ID_No);
        this.textString += append(obj.Transaction_Type_Code);
        this.textString += append(obj.OTHER_BK);
        this.textString += append(obj.UFCE_Amount);
        this.textString += formatDate(item.UFCE_Date);
        this.textString += "||";
      });
      const GSSegment =
        this.JSONData.Item5?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];

      GSSegment.forEach((obj: any) => {
        this.textString += "GS|";
        this.textString += append(obj.Guarantor_DUNS_Number);
        this.textString += append(obj.Guarantor_Type);
        this.textString += append(obj.Business_Category);
        this.textString += append(obj.Business_Industry_Type);
        this.textString += append(obj.Guarantor_Entity_Name);
        this.textString += append(obj.Individual_Name_Prefix);
        this.textString += append(obj.Full_Name);
        this.textString += append(obj.Individual_Name_Suffix);
        this.textString += append(obj.Gender);
        this.textString += append(obj.Company_Registration_Number);
        this.textString += formatDate(obj.Date_of_Incorporation);
        this.textString += formatDate(obj.Date_of_Birth);
        this.textString += append(obj.PAN);
        this.textString += append(obj.Voter_ID);
        this.textString += append(obj.Passport_Number);
        this.textString += append(obj.Driving_Licence_ID);
        this.textString += append(obj.UID);
        this.textString += append(obj.Ration_Card_No);
        this.textString += append(obj.CIN);
        this.textString += append(obj.DIN);
        this.textString += append(obj.TIN);
        this.textString += append(obj.Service_Tax);
        this.textString += append(obj.Other_ID);
        this.textString += append(obj.Address_Line_1);
        this.textString += append(obj.Address_Line_2);
        this.textString += append(obj.Address_Line_3);
        this.textString += append(obj.City_Town);
        this.textString += append(obj.District);
        this.textString += append(obj.State_Union_Territory);
        this.textString += append(obj.Pin_Code);
        this.textString += append(obj.Country);
        this.textString += append(obj.Mobile_Number);
        this.textString += append(obj.Telephone_Area_Code);
        this.textString += append(obj.Telephone_Number);
        this.textString += append(obj.Fax_Area_Code);
        this.textString += append(obj.Fax_Number);
        this.textString += "||";
      });

      // 🔹 SS Segment
      const SSSegment =
        this.JSONData.Item6?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];
      SSSegment.forEach((obj: any) => {
        this.textString += "SS|";
        this.textString += append(obj.Value_of_Security);
        this.textString += append(obj.Currency_Type);
        this.textString += append(obj.Type_of_Security);
        this.textString += append(obj.Security_Classification);
        this.textString += formatDate(obj.Date_of_Valuation);
        this.textString += "||";
      });

      // 🔹 CD Segment
      const CDSegment =
        this.JSONData.Item7?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];
      CDSegment.forEach((obj: any) => {
        this.textString += "CD|";
        this.textString += formatDate(obj.Date_of_Dishonour);
        this.textString += append(obj.Amount);
        this.textString += append(obj.Instrument_Cheque_Number);
        this.textString += append(obj.Number_of_times);
        this.textString += formatDate(obj.dishonoured_Cheque_Issue_Date);
        this.textString += append(obj.Reason_for_Dishonour);
        this.textString += "||";
      });

      const TSSegment =
        this.JSONData.Item8?.filter((x: any) => x.Loan_Id == item.Loan_Id) ||
        [];

      TSSegment.forEach((obj: any) => {
        this.textString += "TS|";
        this.textString += append(obj.Number_of_Borrower_Segments);
        this.textString += append(obj.Number_of_Credit_Facility_Segments);
        this.textString += "||";
      });
    }

    // 📄 Create downloadable text file
    const blob = new Blob([this.textString], { type: "text/plain" });
    console.log("blob:", blob);
    console.log("text:", this.textString);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TextFile-CibilCommercial.txt";
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}
